import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: () => <div>Hello /!</div>,
  beforeLoad: async ({ context: { auth } }) => {
    if (!auth?.isAuthenticated) {
      throw redirect({
        to: '/sign-in',
      });
    }

    if (auth?.isAuthenticated) {
      const isContentCreatorOnly = auth.isContentCreator && auth.user?.roles.length === 1;

      throw redirect({
        to: isContentCreatorOnly ? '/creator/dashboard' : '/user/dashboard',
      });
    }
  },
});
